import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 7],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Line arrays",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "simple",
              options: {
                components: {
                  variant: "layout",
                  data: {
                    type: "table",
                    options: {
                      cols: 2,
                      rows: 1,
                      colsSize: [1.5, 2],
                      components: [
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "text",
                                options: {
                                  data: `<ul>
                                    <li style="font-size: 14px">Line array of N loudspeakers
                                    <li style="font-size: 14px">Speakers are regularly spaced by a distance d
                                    <li style="font-size: 14px">θ is the angle to the axis perpendicular to the array
                                  </ul>`,
                                  formatter: "html",
                                  scrollbars: false,
                                },
                              },
                            },
                          },
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "image",
                                options: {
                                  src: `${config.ASSETS_URL}/04/28/principle/principle-1.svg`,
                                },
                              },
                              styles: {
                                padding: "5%",
                              },
                            },
                          },
                        ],
                      ],
                    },
                    styles: {
                      border: `1px solid ${variables["default"]}`,
                      borderRadius: "10px",
                      padding: "0 3%",
                    },
                  },
                },
              },
              styles: {
                padding: "6% 2%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default components;
